<div class="contentWrapper">
	<mat-icon class="mainIcon" [fontIcon]="icon()" fontSet="fas" inline />
	<label matSnackBarLabel>
		<ng-content select="[label]" />
	</label>

	<div matSnackBarAction class="actions">
		<ng-content select="[actions]" />

		<button mat-icon-button (click)="snackbarRef.dismiss()" class="closeButton">
			<mat-icon fontIcon="fa-times" fontSet="far" />
		</button>
	</div>
</div>
<mat-progress-bar class="timerBar" mode="determinate" [value]="timerPercentage()" />
